import _ from 'lodash';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Label, Segment } from 'semantic-ui-react';
import { uniqueKey } from '../../../global/common/keys';
import { GolfParentContext } from '../cnr/contexts/GolfParentContext';
import { GolfTournamentContext } from '../cnr/contexts/GolfTournamentContext';
import { CreateGolfContext } from '../create/CreateGolf';
import GolferTeam from './GolferTeam';
import GolferTeamSelect from './GolferTeamSelect';

const GolfTeams = (props) => {

  const { forList, forSelect } = props

  // golfParentContext 
  const golfParentContext = useContext(GolfParentContext)
  const { golfParent_contexts } = golfParentContext ?? {}
  const { states, fns } = golfParent_contexts ?? {}
  const { golfTournament_state } = states ?? {}
  const { navigation_fns } = fns ?? {}

  // golfTournamentContext - direct
  const golfTournamentContext = useContext(GolfTournamentContext)
  const { golfTournament_state: gts } = golfTournamentContext ? golfTournamentContext : {}

  // const _golfEvent_state = ges ? ges : golfEvent_state
  const _golfTournament_state = gts ? gts : golfTournament_state

  // createGolfContext
  const createGolfContext = useContext(CreateGolfContext);
  const { golfEvent_state, golfCreate_state } = createGolfContext ? createGolfContext : {}

  // golfEvent
  const { teams: teams_event } = golfEvent_state ?? {}

  // golfCreate
  const { tournamentDetails, rowIndex } = golfCreate_state ? golfCreate_state : {}
  const { golfers: golfers_details } = tournamentDetails ? tournamentDetails : {}

  // golfTournamentContext   
  const { details, golfStyles } = _golfTournament_state ? _golfTournament_state : {}
  const { golfers: golfers_tournament, teams: teams_tournament } = details ?? {}
  const { golfTeam1Style, golfTeam2Style } = golfStyles ?? {}

  const _teams = teams_tournament ? teams_tournament : teams_event

  const [_golfers, set_golfers] = useState()
  const [golfTeamsInfo, setGolfTeamsInfo] = useState()
  const [scrollToIndex, setScrollToIndex] = useState();

  const { team1, team2, team1Count, team2Count, noTeamCount } = golfTeamsInfo ? golfTeamsInfo : {}

  const scrollRef = useRef(null);

  useEffect(() => {
    let _glfs;
    if (forSelect) {
      set_golfers(golfers_details)
    } else {
      if (golfers_tournament) {
        _glfs = { ...golfers_tournament }
        set_golfers(_glfs)
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps 
  }, [golfers_details, golfers_tournament]);

  useEffect(() => {
    if (rowIndex !== null) {
      setScrollToIndex(rowIndex)
    }
  }, [rowIndex]);

  useEffect(() => {
    if (scrollRef && scrollRef.current) {
      if (scrollToIndex) {
        // Scroll the next row into view
        scrollRef.current.children[scrollToIndex].scrollIntoView({
          behavior: 'smooth',
        });

        // Reset the scrollToIndex state after scrolling
        setTimeout(() => {
          setScrollToIndex(null);
        }, 500); // Adjust the delay as needed
      }
    }
  }, [scrollToIndex]);

  useEffect(() => {
    if (_teams && _golfers) {
      let _team1 = _teams ? _.find(_teams, { teamNumber: 1 }) : {}
      let _team2 = _teams ? _.find(_teams, { teamNumber: 2 }) : {}

      if (!_team1) { _team1 = _teams.team1 }
      if (!_team2) { _team2 = _teams.team2 }

      const _golfers_team = _.groupBy(_golfers, 'teamNumber')
      const _golfers_teams = { team1: [], team2: [] }

      if (_golfers_team) {
        Object.keys(_golfers_team).forEach(key => {
          _golfers_teams['team' + key] = _golfers_team[key]
        })
      }

      const _team1Count = _golfers_teams && _golfers_teams.team1 ? _golfers_teams.team1.length : 0
      const _team2Count = _golfers_teams && _golfers_teams.team2 ? _golfers_teams.team2.length : 0

      const _noTeamCount = Object.keys(_golfers).length - (_team1Count + _team2Count)

      setGolfTeamsInfo({ teamz: _golfers_team, team1: _team1, team2: _team2, team1Count: _team1Count, team2Count: _team2Count, noTeamCount: _noTeamCount })
    }
  }, [_teams, _golfers]);

  let cn = 'athletes-container golfers'

  const handleClick = (team) => navigation_fns.handleNav_item({ key: 'tournamentTeams' }, team.teamNumber)

  const teamGolferItem = (golfer, golferTeam, index) =>
    forSelect ?
      <GolferTeamSelect golfer={golfer} golferTeam={golferTeam} rowIndex={index} />
      :
      <GolferTeam key={uniqueKey('gt', 'tgi', index)} golfer={golfer} index={index}
      />

  // returns a list of players
  const teamPlayerList = () => {
    const players = _golfers ? _.orderBy(_golfers, 'lastName') : {}
    if (players && Object.keys(players).length > 0) {
      return Object.keys(players).map((playerKey, index) => {
        const player = players[playerKey]
        const { teamNumber } = player
        let playerTeam;
        if (teamNumber) {
          switch (teamNumber) {
            case 1:
              playerTeam = team1
              break;
            case 2:
              playerTeam = team2
              break;
            default:
            // nothing
          }
        }
        return teamGolferItem(player, playerTeam, index)
      })
    } else {
      return 'None'
    }
  }

  const teamLabel = (team, sty, altName) => <Label
    key={uniqueKey('gt', 'th', 'l')}
    style={sty}
    onClick={() => { handleClick(team) }}>
    {team ? team.name : altName}
  </Label>

  const teamHeader = () => {
    return forSelect ? <div key={uniqueKey('gt', 'th')} className={'athlete-team-header-select'}>
      <div key={uniqueKey('gt', 'th', 1)}>
        <div key={uniqueKey('gt', 'th', 1, 1)} className={'team-1'}>{team1 ? team1.name : 'Team 1'}{' '}</div>
        <div key={uniqueKey('gt', 'th', 1, 0)} className={'team-0'}>{'No Team'}</div>
        <div key={uniqueKey('gt', 'th', 1, 2)} className={'team-2'}>{team2 ? team2.name : 'Team 2'}</div>
      </div>
      <div key={uniqueKey('gt', 'th', 2)}>
        <div key={uniqueKey('gt', 'th', 2, 1)} className={'team-1-c'}> <Label size={'tiny'} color='green'>{team1Count}</Label></div>
        <div key={uniqueKey('gt', 'th', 2, 0)} className={'team-0-c'}> <Label size={'tiny'} color='green'>{noTeamCount}</Label></div>
        <div key={uniqueKey('gt', 'th', 2, 2)} className={'team-2-c'}> <Label size={'tiny'} color='green'>{team2Count}</Label></div>
      </div>
    </div>
      :
      <div key={uniqueKey('gt', 'th', 3)} className={'athlete-team-header'}>
        <div key={uniqueKey('gt', 'th', 3, 1)} className={'team-1'} >{teamLabel(team1, golfTeam1Style, 'Team 1')}</div>
        <div key={uniqueKey('gt', 'th', 3, 2)} className={'team-2'}>{teamLabel(team2, golfTeam2Style, 'Team 2')}</div>
      </div >
  }

  const content = () => <Segment basic className={cn}>
    {teamHeader()}
    <div className={'golfers-team-golfers'} ref={scrollRef} >
      {_golfers && teamPlayerList()}
    </div>
  </Segment>

  return forList ? teamPlayerList() : content()

}

export default GolfTeams